// @flow
import ModalContainer from './ModalContainer';
import Modal from './Modal';

export default ModalContainer;
export { Modal };
